import { IconButton } from '@plato/ui/candidates/icon-button';
import { Container } from '@plato/ui/containers/container';
import { DialogBody, DialogHeader } from '@plato/ui/containers/dialog';
import { ChevronLeftIcon, XIcon } from 'lucide-react';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export type QuoteOrderNotFoundProps = {
    onBack?: () => void;
    onClose?: () => void;
};

/** Shown for a quote or order that no longer resolves, on the route and in the drawer alike. */
export function QuoteOrderNotFound({ onBack, onClose }: QuoteOrderNotFoundProps): ReactElement {
    const { t } = useTranslation();

    return (
        <Container level={1} className="flex h-full min-h-0 w-full grow flex-col bg-neutral-50">
            <DialogHeader>
                {onBack && (
                    <IconButton label={t('back', { ns: 'common' })} onClick={onBack}>
                        <ChevronLeftIcon />
                    </IconButton>
                )}
                <div className="grow" />
                {onClose && (
                    <IconButton label={t('form__close', { ns: 'common' })} onClick={onClose}>
                        <XIcon />
                    </IconButton>
                )}
            </DialogHeader>
            <DialogBody className="flex flex-col gap-container-cozy py-container-cozy">
                <div className="mx-auto flex w-full max-w-7xl flex-auto flex-col justify-center px-6 py-24 sm:py-64 lg:px-8">
                    <p className="text-lg font-semibold leading-8 text-indigo-600">404</p>
                    <h1 className="mt-4 text-3xl font-bold tracking-tight text-neutral-900 sm:text-5xl">
                        {t('not_found_drawer__title')}
                    </h1>
                    <p className="mt-6 text-lg leading-7 text-neutral-600">
                        {t('not_found_drawer__description')}
                    </p>
                </div>
            </DialogBody>
        </Container>
    );
}
